import React, { useState, useEffect, useRef } from 'react';

const API = 'https://sashtimedix.in/api';

function App() {
  const [screen, setScreen] = useState('login');
  const [tab, setTab] = useState('pos');
  const [phone, setPhone] = useState('');
  const [pass, setPass] = useState('');
  const [token, setToken] = useState(localStorage.getItem('vtoken') || '');
  const [vendor, setVendor] = useState(null);
  const [drugs, setDrugs] = useState([]);
  const [bills, setBills] = useState([]);
  const [grns, setGrns] = useState([]);
  const [suppliers, setSuppliers] = useState([]);
  const [ledgers, setLedgers] = useState([]);
  const [expenses, setExpenses] = useState([]);
  const [expiring, setExpiring] = useState([]);
  const [lowStock, setLowStock] = useState([]);
  const [report, setReport] = useState({});
  const [trend, setTrend] = useState([]);
  const [loading, setLoading] = useState(false);
  const [darkMode, setDarkMode] = useState(() => localStorage.getItem('erp_dark') === '1');
  useEffect(() => { localStorage.setItem('erp_dark', darkMode ? '1' : '0'); }, [darkMode]);

  // POS State
  const [posItems, setPosItems] = useState([]);
  const [custName, setCustName] = useState('');
  const [custPhone, setCustPhone] = useState('');
  const [discount, setDiscount] = useState(0);
  const [payMethod, setPayMethod] = useState('cash');
  const [payStatus, setPayStatus] = useState('paid');
  const [drugSearch, setDrugSearch] = useState('');
  const [billSuccess, setBillSuccess] = useState(null);
  const [showScanner, setShowScanner] = useState(false);
  const [scannerMsg, setScannerMsg] = useState('');
  const videoRef = useRef(null);
  const streamRef = useRef(null);

  const lookupBarcode = async (code) => {
    if (!code) return;
    try {
      const res = await fetch(`${API}/v2/vendor/drugs/barcode/${code}`, { headers: h });
      const data = await res.json();
      if (data && data._id) { addToPos(data); }
      else alert('இந்த barcode-க்கு மருந்து கிடைக்கவில்லை. Drug Master-ல முதலில் barcode assign பண்ணுங்க.');
    } catch (err) { console.log(err); }
  };

  const stopScanner = () => {
    setShowScanner(false);
    if (streamRef.current) { streamRef.current.getTracks().forEach(t => t.stop()); streamRef.current = null; }
  };

  const startCameraScan = () => {
    if (!('BarcodeDetector' in window)) {
      alert('இந்த browser-ல camera barcode scan support இல்ல. USB/Bluetooth barcode scanner இருந்தா, search box-ல click பண்ணி நேரடியா scan பண்ணுங்க — அது தானாகவே வேலை செய்யும்.');
      return;
    }
    setScannerMsg('');
    setShowScanner(true);
  };

  useEffect(() => {
    if (!showScanner) return;
    let active = true;
    (async () => {
      try {
        const detector = new window.BarcodeDetector({ formats: ['ean_13','ean_8','upc_a','upc_e','code_128','code_39','qr_code'] });
        const stream = await navigator.mediaDevices.getUserMedia({ video: { facingMode: 'environment' } });
        streamRef.current = stream;
        if (videoRef.current) { videoRef.current.srcObject = stream; await videoRef.current.play(); }
        const scanLoop = async () => {
          if (!active || !videoRef.current) return;
          try {
            const codes = await detector.detect(videoRef.current);
            if (codes.length > 0) {
              const code = codes[0].rawValue;
              active = false;
              stopScanner();
              lookupBarcode(code);
              return;
            }
          } catch (e) {}
          if (active) requestAnimationFrame(scanLoop);
        };
        scanLoop();
      } catch (err) {
        setScannerMsg('Camera access கிடைக்கவில்லை: ' + err.message);
      }
    })();
    return () => { active = false; if (streamRef.current) { streamRef.current.getTracks().forEach(t => t.stop()); streamRef.current = null; } };
  }, [showScanner]);


  // GRN State
  const [showGRN, setShowGRN] = useState(false);
  const [grnSupplier, setGrnSupplier] = useState('');
  const [grnInvoice, setGrnInvoice] = useState('');
  const [grnItems, setGrnItems] = useState([]);
  const [grnDrugSearch, setGrnDrugSearch] = useState('');

  // Add Drug State
  const [showAddDrug, setShowAddDrug] = useState(false);
  const [newDrug, setNewDrug] = useState({name:'',genericName:'',saltComposition:'',manufacturer:'',drugType:'tablet',schedule:'OTC',gstPercent:12,mrp:'',salePrice:'',purchasePrice:'',unit:'strip',packSize:10,minStock:20,rx:false,barcode:''});
  const [newBatch, setNewBatch] = useState({batchNo:'',expiryDate:'',mfgDate:'',stock:'',purchasePrice:''});

  // Expense State
  const [showExpense, setShowExpense] = useState(false);
  const [expense, setExpense] = useState({category:'',amount:'',note:''});

  // Supplier State
  const [showAddSupplier, setShowAddSupplier] = useState(false);
  const [newSupplier, setNewSupplier] = useState({name:'',phone:'',gstNumber:'',address:''});

  // Edit Drug State
  const [editDrug, setEditDrug] = useState(null);

  const h = { Authorization: `Bearer ${token}` };
  const hj = { ...h, 'Content-Type': 'application/json' };
  const hdr = {background:'linear-gradient(135deg,#1a237e,#283593)',padding:'12px 16px',display:'flex',justifyContent:'space-between',alignItems:'center'};
  const btn = (bg='linear-gradient(135deg,#1a237e,#283593)') => ({background:bg,color:'white',border:'none',borderRadius:'8px',padding:'8px 14px',cursor:'pointer',fontSize:'13px',fontWeight:'bold'});
  const inp = {width:'100%',padding:'10px',borderRadius:'8px',border:'1px solid #ddd',boxSizing:'border-box',marginBottom:'8px',fontSize:'13px'};
  const navBtn = (t) => ({flex:1,padding:'8px 0',border:'none',background:tab===t?'linear-gradient(135deg,#1a237e,#283593)':'white',color:tab===t?'white':'#666',cursor:'pointer',fontSize:'9px',fontWeight:tab===t?'bold':'normal'});

  useEffect(() => { if(token){setScreen('app');fetchAll();} }, [token]);

  useEffect(() => {
    const style = document.createElement('style');
    style.setAttribute('data-erp-responsive', 'true');
    style.innerHTML = `
      @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&family=Poppins:wght@600;700;800&display=swap');
      .erp-shell, .erp-shell input, .erp-shell button, .erp-shell select { font-family: 'Inter', -apple-system, sans-serif; }
      .erp-shell h1, .erp-shell h2, .erp-shell h3, .erp-shell h4 { font-family: 'Poppins', 'Inter', sans-serif; }
      .erp-shell { max-width: 600px; margin: 0 auto; }
      .erp-nav { max-width: 600px; }
      @media (min-width: 900px) {
        body { background: #eef1f4; }
        .erp-shell { max-width: 980px; box-shadow: 0 0 40px rgba(0,0,0,0.08); }
        .erp-nav { max-width: 980px; }
      }
      .erp-shell button { transition: transform 0.15s ease, box-shadow 0.15s ease, opacity 0.15s ease; }
      .erp-shell button:active { transform: scale(0.95); }
      .erp-shell input, .erp-shell select { transition: border-color 0.15s ease, box-shadow 0.15s ease; }
      .erp-shell input:focus, .erp-shell select:focus { border-color: #1a237e !important; box-shadow: 0 0 0 3px rgba(26,35,126,0.12); outline: none; }
      .erp-dark { filter: invert(1) hue-rotate(180deg); background: #fff; }
      .erp-dark img, .erp-dark svg { filter: invert(1) hue-rotate(180deg); }
      .erp-card { transition: transform 0.2s ease, box-shadow 0.2s ease; }
      .erp-card:hover { transform: translateY(-3px); box-shadow: 0 10px 20px rgba(0,0,0,0.1) !important; }
      .erp-shell button:hover { filter: brightness(1.08); }
    `;
    if (!document.querySelector('style[data-erp-responsive]')) document.head.appendChild(style);
  }, []);

  const fetchAll = async () => {
    try {
      const [v,d,b,g,s,l,e,ex,ls,r,tr] = await Promise.all([
        fetch(`${API}/vendor/profile`,{headers:h}).then(x=>x.json()),
        fetch(`${API}/v2/vendor/drugs`,{headers:h}).then(x=>x.json()),
        fetch(`${API}/v2/vendor/bills`,{headers:h}).then(x=>x.json()),
        fetch(`${API}/v2/vendor/grn`,{headers:h}).then(x=>x.json()),
        fetch(`${API}/vendor/suppliers`,{headers:h}).then(x=>x.json()),
        fetch(`${API}/vendor/ledger`,{headers:h}).then(x=>x.json()),
        fetch(`${API}/vendor/expenses`,{headers:h}).then(x=>x.json()),
        fetch(`${API}/v2/vendor/drugs/expiring/90`,{headers:h}).then(x=>x.json()),
        fetch(`${API}/v2/vendor/drugs/lowstock`,{headers:h}).then(x=>x.json()),
        fetch(`${API}/v2/vendor/reports/summary`,{headers:h}).then(x=>x.json()),
        fetch(`${API}/v2/vendor/reports/trend?days=7`,{headers:h}).then(x=>x.json()),
      ]);
      setVendor(v);
      setDrugs(Array.isArray(d)?d:[]);
      setBills(Array.isArray(b)?b:[]);
      setGrns(Array.isArray(g)?g:[]);
      setSuppliers(Array.isArray(s)?s:[]);
      setLedgers(Array.isArray(l)?l:[]);
      setExpenses(Array.isArray(e)?e:[]);
      setExpiring(Array.isArray(ex)?ex:[]);
      setLowStock(Array.isArray(ls)?ls:[]);
      setReport(r||{});
      setTrend(Array.isArray(tr)?tr:[]);
    } catch(err){console.log(err);}
  };

  const login = async () => {
    setLoading(true);
    const res = await fetch(`${API}/vendor/login`,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({phone,password:pass})});
    const data = await res.json();
    if(data.success){localStorage.setItem('vtoken',data.token);setToken(data.token);}
    else alert(data.error);
    setLoading(false);
  };

  const addToPos = (drug) => {
    setPosItems(prev=>{
      const ex=prev.find(i=>i._id===drug._id);
      if(ex) return prev.map(i=>i._id===drug._id?{...i,qty:i.qty+1}:i);
      return [...prev,{...drug,qty:1}];
    });
    setDrugSearch('');
  };

  const subtotal = posItems.reduce((a,i)=>a+(i.salePrice*i.qty),0);
  const gstTotal = posItems.reduce((a,i)=>a+(i.salePrice*i.qty*(i.gstPercent||12)/100),0);
  const grandTotal = subtotal+gstTotal-discount;

  const createBill = async () => {
    if(posItems.length===0) return alert('மருந்து சேர்க்கவும்');
    setLoading(true);
    const res = await fetch(`${API}/v2/vendor/bill`,{
      method:'POST', headers:hj,
      body:JSON.stringify({
        customerName:custName||'Walk-in Customer',
        customerPhone:custPhone,
        items:posItems.map(i=>({
          medicineId:i._id,name:i.name,
          batchNo:i.batches?.[0]?.batchNo||'',
          hsnCode:i.hsnCode||'3004',
          qty:i.qty,price:i.salePrice,
          gstPercent:i.gstPercent||12
        })),
        discount:Number(discount)||0,
        paymentMethod:payMethod,
        paymentStatus:payStatus
      })
    });
    const data = await res.json();
    if(data.success){
      setBillSuccess(data.bill);
      setPosItems([]);setCustName('');setCustPhone('');setDiscount(0);
      fetchAll();
    } else alert(data.error);
    setLoading(false);
  };

  const addGrnItem = (drug) => {
    setGrnItems(prev=>[...prev,{
      drugId:drug._id,drugName:drug.name,
      batchNo:'',mfgDate:'',expiryDate:'',
      qty:1,freeQty:0,purchasePrice:drug.purchasePrice||0,
      mrp:drug.mrp||0,discount:0,gstPercent:drug.gstPercent||12
    }]);
    setGrnDrugSearch('');
  };

  const submitGRN = async () => {
    if(grnItems.length===0) return alert('மருந்து சேர்க்கவும்');
    setLoading(true);
    const res = await fetch(`${API}/v2/vendor/grn`,{
      method:'POST',headers:hj,
      body:JSON.stringify({
        supplierName:grnSupplier,
        invoiceNo:grnInvoice,
        items:grnItems,
        paymentStatus:'pending',
        paidAmount:0
      })
    });
    const data = await res.json();
    if(data.success){
      alert(`GRN #${data.grn.grnNo} உருவாக்கப்பட்டது! Stock update ஆச்சு.`);
      setShowGRN(false);setGrnItems([]);setGrnSupplier('');setGrnInvoice('');
      fetchAll();
    } else alert(data.error);
    setLoading(false);
  };

  const addDrug = async () => {
    const res = await fetch(`${API}/v2/vendor/drugs`,{
      method:'POST',headers:hj,
      body:JSON.stringify({
        ...newDrug,
        mrp:Number(newDrug.mrp),salePrice:Number(newDrug.salePrice),
        purchasePrice:Number(newDrug.purchasePrice),
        batches:newBatch.batchNo?[{...newBatch,stock:Number(newBatch.stock),purchasePrice:Number(newBatch.purchasePrice)}]:[],
        totalStock:newBatch.stock?Number(newBatch.stock):0
      })
    });
    const data = await res.json();
    if(data.success){setShowAddDrug(false);fetchAll();alert('மருந்து சேர்க்கப்பட்டது!');}
    else alert(data.error);
  };

  const addExpense = async () => {
    const res = await fetch(`${API}/vendor/expense`,{method:'POST',headers:hj,body:JSON.stringify({...expense,amount:Number(expense.amount)})});
    const data = await res.json();
    if(data.success){setShowExpense(false);setExpense({category:'',amount:'',note:''});fetchAll();alert('செலவு சேர்க்கப்பட்டது!');}
  };

  const addSupplier = async () => {
    if(!newSupplier.name) return alert('Supplier பெயர் கொடுங்க');
    const res = await fetch(`${API}/vendor/suppliers`,{method:'POST',headers:hj,body:JSON.stringify(newSupplier)});
    const data = await res.json();
    if(data && data._id){ setShowAddSupplier(false); setNewSupplier({name:'',phone:'',gstNumber:'',address:''}); fetchAll(); alert('Supplier சேர்க்கப்பட்டது!'); }
    else alert(data.error||'Error');
  };

  const paySupplier = async (supplier) => {
    const amtStr = prompt(`${supplier.name}-க்கு எவ்ளோ pay பண்றீங்க? (Due: ₹${supplier.totalDue.toFixed(2)})`, supplier.totalDue);
    if(!amtStr) return;
    const amount = Number(amtStr);
    if(!amount || amount<=0) return alert('சரியான தொகை கொடுங்க');
    const res = await fetch(`${API}/v2/vendor/supplier-payment/${supplier._id}`,{method:'POST',headers:hj,body:JSON.stringify({amount})});
    const data = await res.json();
    if(data.success){ fetchAll(); alert('Payment record ஆச்சு!'); }
    else alert(data.error||'Error');
  };

  const saveEditDrug = async () => {
    if(!editDrug) return;
    const { _id, batches, totalStock, createdAt, __v, ...updateData } = editDrug;
    const res = await fetch(`${API}/v2/vendor/drugs/${_id}`,{
      method:'PUT',headers:hj,
      body:JSON.stringify({...updateData,mrp:Number(updateData.mrp),salePrice:Number(updateData.salePrice),purchasePrice:Number(updateData.purchasePrice),gstPercent:Number(updateData.gstPercent),minStock:Number(updateData.minStock)})
    });
    const data = await res.json();
    if(data.success){ setEditDrug(null); fetchAll(); alert('மருந்து update ஆச்சு!'); }
    else alert(data.error||'Error');
  };

  const deleteDrug = async (drug) => {
    if(!window.confirm(`"${drug.name}"-ஐ நிச்சயமா delete பண்றீங்களா? (Bills/reports history பாதிக்கப்படாது)`)) return;
    const res = await fetch(`${API}/v2/vendor/drugs/${drug._id}`,{method:'DELETE',headers:h});
    const data = await res.json();
    if(data.success){ fetchAll(); }
    else alert(data.error||'Error');
  };

  const logout = () => {localStorage.removeItem('vtoken');setToken('');setScreen('login');};

  const filteredDrugs = drugs.filter(d=>d.name?.toLowerCase().includes(drugSearch.toLowerCase())||d.genericName?.toLowerCase().includes(drugSearch.toLowerCase()));
  const filteredGrnDrugs = drugs.filter(d=>d.name?.toLowerCase().includes(grnDrugSearch.toLowerCase())||d.genericName?.toLowerCase().includes(grnDrugSearch.toLowerCase()));

  const scheduleColor = {OTC:'#2e7d32',H:'#e65100',H1:'#c62828',X:'#4a148c',G:'#1565c0'};

  if(screen==='login') return (
    <div style={{minHeight:'100vh',background:'#e8eaf6',display:'flex',alignItems:'center',justifyContent:'center'}}>
      <div style={{background:'white',padding:'40px',borderRadius:'16px',width:'340px',boxShadow:'0 4px 20px rgba(0,0,0,0.1)'}}>
        <div style={{textAlign:'center',marginBottom:'24px'}}>
          <div style={{fontSize:'50px'}}>🏥</div>
          <h2 style={{color:'#1a237e',margin:'8px 0'}}>Pharmacy ERP</h2>
          <p style={{color:'#666',fontSize:'13px'}}>Sashtimedix — Full ERP System</p>
        </div>
        <input placeholder="📱 தொலைபேசி எண்" value={phone} onChange={e=>setPhone(e.target.value)} style={inp}/>
        <input type="password" placeholder="🔒 கடவுச்சொல்" value={pass} onChange={e=>setPass(e.target.value)} style={inp}/>
        <button onClick={login} disabled={loading} style={{...btn(),width:'100%',padding:'14px',fontSize:'16px'}}>
          {loading?'⏳...':'Login →'}
        </button>
        <p style={{textAlign:'center',color:'#999',fontSize:'11px',marginTop:'14px'}}>Vendor account-க்கு contact பண்ணி credentials வாங்குங்க</p>
      </div>
    </div>
  );

  if(billSuccess) return (
    <div className="erp-shell" style={{fontFamily:'sans-serif',minHeight:'100vh',background:'#f5f5f5'}}>
      <div style={hdr}>
        <h2 style={{color:'white',margin:0,fontSize:'16px'}}>🧾 {billSuccess.billNo}</h2>
        <button onClick={()=>setBillSuccess(null)} style={{...btn('rgba(255,255,255,0.2)'),fontSize:'11px'}}>புதிய Bill</button>
      </div>
      <div style={{padding:'16px'}}>
        <div style={{background:'white',borderRadius:'12px',padding:'20px',boxShadow:'0 2px 8px rgba(0,0,0,0.08)'}}>
          <div style={{textAlign:'center',marginBottom:'16px',borderBottom:'2px dashed #eee',paddingBottom:'12px'}}>
            <h3 style={{color:'#1a237e',margin:'0 0 4px'}}>{vendor?.name}</h3>
            <p style={{color:'#666',fontSize:'12px',margin:'0 0 2px'}}>{vendor?.area}</p>
            <p style={{color:'#999',fontSize:'11px',margin:0}}>Bill: {billSuccess.billNo} | {new Date().toLocaleDateString('ta-IN')}</p>
          </div>
          <p style={{fontSize:'13px',margin:'0 0 10px'}}><strong>Customer:</strong> {billSuccess.customerName} {billSuccess.customerPhone&&`| 📱 ${billSuccess.customerPhone}`}</p>
          <table style={{width:'100%',borderCollapse:'collapse',fontSize:'11px',marginBottom:'12px'}}>
            <thead>
              <tr style={{background:'#f0f4ff'}}>
                {['மருந்து','Batch','Qty','Rate','GST%','Total'].map((h,i)=>(
                  <th key={i} style={{padding:'5px',border:'1px solid #e0e0e0',textAlign:i>1?'right':'left'}}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {billSuccess.items?.map((item,i)=>(
                <tr key={i}>
                  <td style={{padding:'5px',border:'1px solid #e0e0e0'}}>
                    <div style={{fontWeight:'bold'}}>{item.name}</div>
                    <div style={{color:'#999',fontSize:'10px'}}>HSN: {item.hsnCode}</div>
                  </td>
                  <td style={{padding:'5px',border:'1px solid #e0e0e0',fontSize:'10px'}}>{item.batchNo||'-'}</td>
                  <td style={{padding:'5px',border:'1px solid #e0e0e0',textAlign:'right'}}>{item.qty}</td>
                  <td style={{padding:'5px',border:'1px solid #e0e0e0',textAlign:'right'}}>₹{item.price}</td>
                  <td style={{padding:'5px',border:'1px solid #e0e0e0',textAlign:'right'}}>{item.gstPercent}%</td>
                  <td style={{padding:'5px',border:'1px solid #e0e0e0',textAlign:'right',fontWeight:'bold'}}>₹{item.total?.toFixed(2)}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <div style={{fontSize:'12px',borderTop:'1px solid #eee',paddingTop:'8px'}}>
            {[['Subtotal',`₹${billSuccess.subtotal?.toFixed(2)}`],['CGST',`₹${billSuccess.totalCgst?.toFixed(2)}`],['SGST',`₹${billSuccess.totalSgst?.toFixed(2)}`],billSuccess.discount>0?['Discount',`-₹${billSuccess.discount}`]:null].filter(Boolean).map(([l,v],i)=>(
              <div key={i} style={{display:'flex',justifyContent:'space-between',marginBottom:'4px',color:'#666'}}><span>{l}</span><span>{v}</span></div>
            ))}
            <div style={{display:'flex',justifyContent:'space-between',fontWeight:'bold',fontSize:'15px',color:'#1a237e',borderTop:'2px solid #1a237e',paddingTop:'6px',marginTop:'4px'}}>
              <span>Grand Total</span><span>₹{billSuccess.grandTotal?.toFixed(2)}</span>
            </div>
            <div style={{textAlign:'center',color:'#666',fontSize:'11px',marginTop:'8px'}}>
              {billSuccess.paymentMethod?.toUpperCase()} | {billSuccess.paymentStatus==='paid'?'✅ PAID':'⏳ DUE'}
            </div>
          </div>
          <div style={{textAlign:'center',marginTop:'12px',borderTop:'1px dashed #eee',paddingTop:'10px',color:'#999',fontSize:'11px'}}>
            <p style={{margin:'0 0 2px'}}>நன்றி! Thank you for your purchase.</p>
            <p style={{margin:0}}>sashtimedix.in | {vendor?.area}</p>
          </div>
        </div>
        <div style={{display:'flex',gap:'8px',marginTop:'12px'}}>
          <button onClick={()=>window.print()} style={{...btn(),flex:1,padding:'12px'}}>🖨️ Print</button>
          <button onClick={()=>setBillSuccess(null)} style={{...btn('linear-gradient(135deg,#2e7d32,#1b5e20)'),flex:1,padding:'12px'}}>➕ புதிய Bill</button>
        </div>
      </div>
    </div>
  );

  return (
    <div className={"erp-shell" + (darkMode ? " erp-dark" : "")} style={{fontFamily:'sans-serif',minHeight:'100vh',background:'#f5f5f5',paddingBottom:'65px'}}>
      <div style={hdr}>
        <div>
          <div style={{color:'white',fontWeight:'bold',fontSize:'15px'}}>🏥 {vendor?.name||'ERP'}</div>
          <div style={{color:'rgba(255,255,255,0.8)',fontSize:'10px'}}>Full Pharmacy ERP | Sashtimedix</div>
        </div>
        <div style={{display:'flex',gap:'8px',alignItems:'center'}}>
          <button onClick={()=>setDarkMode(d=>!d)} style={{...btn('rgba(255,255,255,0.2)'),fontSize:'13px',padding:'4px 8px'}}>{darkMode?'☀️':'🌙'}</button>
          {expiring.filter(e=>e.status==='critical').length>0&&<span style={{background:'#c62828',color:'white',borderRadius:'10px',padding:'2px 8px',fontSize:'10px',fontWeight:'bold'}}>⚠️ {expiring.filter(e=>e.status==='critical').length} Expiring!</span>}
          <button onClick={logout} style={{...btn('rgba(255,255,255,0.2)'),fontSize:'11px',padding:'4px 8px'}}>Exit</button>
        </div>
      </div>

      {/* POS BILLING */}
      {tab==='pos'&&(
        <div style={{padding:'12px'}}>
          <div style={{background:'white',borderRadius:'12px',padding:'14px',marginBottom:'10px',boxShadow:'0 2px 8px rgba(0,0,0,0.07)'}}>
            <h3 style={{color:'#1a237e',margin:'0 0 10px',fontSize:'16px'}}>🧾 Quick Billing</h3>
            <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'8px',marginBottom:'8px'}}>
              <input placeholder="Customer பெயர்" value={custName} onChange={e=>setCustName(e.target.value)} style={{...inp,marginBottom:0}}/>
              <input placeholder="Phone" value={custPhone} onChange={e=>setCustPhone(e.target.value)} style={{...inp,marginBottom:0}}/>
            </div>
            <div style={{display:'flex',gap:'8px',marginBottom:'8px'}}>
              <input placeholder="🔍 மருந்து பெயர் / Generic / Barcode scan..." value={drugSearch}
                onChange={e=>setDrugSearch(e.target.value)}
                onKeyDown={e=>{ if(e.key==='Enter' && /^\d{6,}$/.test(drugSearch.trim())){ lookupBarcode(drugSearch.trim()); setDrugSearch(''); } }}
                style={{...inp,marginBottom:0,flex:1}}/>
              <button onClick={startCameraScan} style={{...btn('linear-gradient(135deg,#2e7d32,#1b5e20)'),padding:'0 16px',fontSize:'18px'}}>📷</button>
            </div>
            {drugSearch&&(
              <div style={{background:'#f8f9fa',borderRadius:'8px',maxHeight:'220px',overflow:'auto',marginBottom:'10px',border:'1px solid #e0e0e0'}}>
                {filteredDrugs.slice(0,8).map(drug=>(
                  <div key={drug._id} onClick={()=>addToPos(drug)}
                    style={{padding:'10px 12px',cursor:'pointer',borderBottom:'1px solid #f0f0f0',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
                    <div>
                      <div style={{fontWeight:'bold',fontSize:'13px'}}>{drug.name}</div>
                      <div style={{color:'#666',fontSize:'11px'}}>{drug.genericName} | Stock: {drug.totalStock}</div>
                      <div style={{fontSize:'10px',display:'flex',gap:'4px',marginTop:'2px'}}>
                        <span style={{background:scheduleColor[drug.schedule]+'22',color:scheduleColor[drug.schedule],padding:'1px 5px',borderRadius:'4px',fontWeight:'bold'}}>{drug.schedule}</span>
                        <span style={{background:'#f0f0f0',padding:'1px 5px',borderRadius:'4px'}}>GST {drug.gstPercent}%</span>
                      </div>
                    </div>
                    <div style={{textAlign:'right'}}>
                      <div style={{color:'#2e7d32',fontWeight:'bold'}}>₹{drug.salePrice}</div>
                      <div style={{color:'#999',fontSize:'10px',textDecoration:'line-through'}}>₹{drug.mrp}</div>
                    </div>
                  </div>
                ))}
                {filteredDrugs.length===0&&<div style={{padding:'12px',color:'#999',textAlign:'center',fontSize:'13px'}}>மருந்து கிடைக்கவில்லை</div>}
              </div>
            )}
            {posItems.length>0&&(
              <>
                <div style={{marginBottom:'10px'}}>
                  {posItems.map((item,i)=>(
                    <div key={i} style={{display:'flex',alignItems:'center',gap:'6px',marginBottom:'6px',background:'#f0f4ff',borderRadius:'8px',padding:'8px 10px'}}>
                      <div style={{flex:1}}>
                        <div style={{fontSize:'13px',fontWeight:'bold',color:'#1a237e'}}>{item.name}</div>
                        <div style={{fontSize:'10px',color:'#666'}}>₹{item.salePrice} | GST {item.gstPercent}% | {item.schedule}</div>
                      </div>
                      <div style={{display:'flex',alignItems:'center',gap:'4px'}}>
                        <button onClick={()=>setPosItems(p=>p.map(x=>x._id===item._id?{...x,qty:Math.max(1,x.qty-1)}:x))} style={{width:'26px',height:'26px',borderRadius:'50%',border:'1px solid #c5d0ff',background:'white',cursor:'pointer',fontSize:'14px',color:'#1a237e'}}>−</button>
                        <span style={{fontWeight:'bold',minWidth:'22px',textAlign:'center',fontSize:'13px'}}>{item.qty}</span>
                        <button onClick={()=>setPosItems(p=>p.map(x=>x._id===item._id?{...x,qty:x.qty+1}:x))} style={{width:'26px',height:'26px',borderRadius:'50%',border:'1px solid #c5d0ff',background:'white',cursor:'pointer',fontSize:'14px',color:'#1a237e'}}>+</button>
                        <button onClick={()=>setPosItems(p=>p.filter(x=>x._id!==item._id))} style={{width:'26px',height:'26px',borderRadius:'50%',border:'none',background:'#ffebee',color:'#c62828',cursor:'pointer',fontSize:'12px'}}>✕</button>
                      </div>
                      <div style={{fontWeight:'bold',color:'#1a237e',minWidth:'65px',textAlign:'right',fontSize:'13px'}}>₹{(item.salePrice*item.qty).toFixed(2)}</div>
                    </div>
                  ))}
                </div>
                <div style={{background:'#f0f4ff',borderRadius:'10px',padding:'12px',marginBottom:'10px'}}>
                  <div style={{display:'flex',justifyContent:'space-between',marginBottom:'4px',fontSize:'13px'}}><span>Subtotal</span><span>₹{subtotal.toFixed(2)}</span></div>
                  <div style={{display:'flex',justifyContent:'space-between',marginBottom:'4px',fontSize:'12px',color:'#666'}}><span>CGST + SGST</span><span>₹{gstTotal.toFixed(2)}</span></div>
                  <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:'8px',fontSize:'13px'}}>
                    <span>Discount ₹</span>
                    <input type="number" value={discount} onChange={e=>setDiscount(Number(e.target.value))} style={{width:'80px',padding:'4px 8px',borderRadius:'6px',border:'1px solid #c5d0ff',textAlign:'right',fontSize:'13px'}}/>
                  </div>
                  <div style={{display:'flex',justifyContent:'space-between',fontWeight:'bold',fontSize:'16px',color:'#1a237e',borderTop:'2px solid #c5d0ff',paddingTop:'8px'}}>
                    <span>Grand Total</span><span>₹{grandTotal.toFixed(2)}</span>
                  </div>
                </div>
                <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'8px',marginBottom:'10px'}}>
                  <select value={payMethod} onChange={e=>setPayMethod(e.target.value)} style={{padding:'8px',borderRadius:'8px',border:'1px solid #ddd',fontSize:'13px'}}>
                    <option value="cash">💵 Cash</option>
                    <option value="upi">📱 UPI / GPay</option>
                    <option value="card">💳 Card</option>
                    <option value="credit">📋 Credit</option>
                  </select>
                  <select value={payStatus} onChange={e=>setPayStatus(e.target.value)} style={{padding:'8px',borderRadius:'8px',border:'1px solid #ddd',fontSize:'13px'}}>
                    <option value="paid">✅ Paid Full</option>
                    <option value="due">⏳ Due</option>
                    <option value="partial">🔄 Partial</option>
                  </select>
                </div>
                <button onClick={createBill} disabled={loading} style={{...btn(),width:'100%',padding:'14px',fontSize:'15px'}}>
                  {loading?'⏳ Bill உருவாக்குகிறோம்...':'🖨️ Bill — ₹'+grandTotal.toFixed(2)}
                </button>
              </>
            )}
          </div>
        </div>
      )}

      {/* DASHBOARD */}
      {tab==='dashboard'&&(
        <div style={{padding:'12px'}}>
          <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'10px',marginBottom:'14px'}}>
            {[
              ['💰','இன்று விற்பனை',`₹${(report.todaySales||0).toFixed(2)}`,'#e8f5e9','#2e7d32'],
              ['🧾','இன்று Bills',`${report.todayBillCount||0}`,'#e3f2fd','#1565c0'],
              ['📊','இன்று GST',`₹${(report.todayGst||0).toFixed(2)}`,'#f3e5f5','#4a148c'],
              ['⏳','நிலுவை Due',`₹${(report.totalDue||0).toFixed(2)}`,'#fff3e0','#e65100'],
              ['⚠️','Low Stock',`${lowStock.length}`,'#ffebee','#c62828'],
              ['🗓️','Expiring 90d',`${expiring.length}`,'#fce4ec','#880e4f'],
            ].map(([icon,label,val,bg,color],i)=>(
              <div key={i} className="erp-card" style={{background:bg,borderRadius:'12px',padding:'14px',boxShadow:'0 2px 6px rgba(0,0,0,0.06)'}}>
                <div style={{fontSize:'22px'}}>{icon}</div>
                <div style={{color:'#666',fontSize:'11px'}}>{label}</div>
                <div style={{color,fontWeight:'bold',fontSize:'17px'}}>{val}</div>
              </div>
            ))}
          </div>

          {/* SALES CHART - last 7 days */}
          {trend.length>0&&(
            <div style={{background:'white',borderRadius:'12px',padding:'14px',marginBottom:'12px',boxShadow:'0 2px 8px rgba(0,0,0,0.07)'}}>
              <h3 style={{color:'#1a237e',margin:'0 0 12px',fontSize:'14px'}}>📈 கடந்த 7 நாட்கள் விற்பனை</h3>
              {(() => {
                const maxVal = Math.max(...trend.map(t=>t.total), 1);
                return (
                  <div style={{display:'flex',alignItems:'flex-end',gap:'8px',height:'140px',padding:'0 4px'}}>
                    {trend.map((t,i)=>{
                      const h = Math.max((t.total/maxVal)*110, t.total>0?4:2);
                      const d = new Date(t.date+'T00:00:00');
                      const label = d.toLocaleDateString('ta-IN',{weekday:'short'});
                      return (
                        <div key={i} style={{flex:1,display:'flex',flexDirection:'column',alignItems:'center',gap:'4px'}}>
                          <div style={{fontSize:'9px',color:'#666',fontWeight:'bold'}}>{t.total>0?`₹${Math.round(t.total)}`:''}</div>
                          <div style={{width:'100%',maxWidth:'28px',height:`${h}px`,background:'linear-gradient(180deg,#3949ab,#1a237e)',borderRadius:'6px 6px 2px 2px',transition:'height 0.4s ease'}}></div>
                          <div style={{fontSize:'10px',color:'#999'}}>{label}</div>
                        </div>
                      );
                    })}
                  </div>
                );
              })()}
              <div style={{display:'flex',justifyContent:'space-between',marginTop:'10px',paddingTop:'10px',borderTop:'1px solid #f0f0f0',fontSize:'12px'}}>
                <span style={{color:'#666'}}>வார மொத்த விற்பனை</span>
                <span style={{fontWeight:'bold',color:'#2e7d32'}}>₹{trend.reduce((a,t)=>a+t.total,0).toFixed(2)}</span>
              </div>
            </div>
          )}

          {expiring.filter(e=>e.status!=='').length>0&&(
            <div style={{background:'white',borderRadius:'12px',padding:'14px',marginBottom:'12px',boxShadow:'0 2px 8px rgba(0,0,0,0.07)'}}>
              <h3 style={{color:'#c62828',margin:'0 0 10px',fontSize:'14px'}}>⚠️ Expiry Alerts</h3>
              {expiring.slice(0,5).map((item,i)=>(
                <div key={i} style={{display:'flex',justifyContent:'space-between',alignItems:'center',padding:'8px',background:item.status==='expired'?'#ffebee':item.status==='critical'?'#fff3e0':'#f9f9f9',borderRadius:'8px',marginBottom:'6px',fontSize:'12px'}}>
                  <div>
                    <div style={{fontWeight:'bold'}}>{item.name}</div>
                    <div style={{color:'#666'}}>Batch: {item.batchNo} | Stock: {item.stock}</div>
                  </div>
                  <div style={{textAlign:'right'}}>
                    <div style={{fontWeight:'bold',color:item.status==='expired'?'#c62828':item.status==='critical'?'#e65100':'#f57f17'}}>
                      {item.daysLeft<0?'EXPIRED':`${item.daysLeft} நாட்கள்`}
                    </div>
                    <div style={{color:'#999',fontSize:'10px'}}>{new Date(item.expiryDate).toLocaleDateString('ta-IN')}</div>
                  </div>
                </div>
              ))}
            </div>
          )}

          {lowStock.length>0&&(
            <div style={{background:'white',borderRadius:'12px',padding:'14px',marginBottom:'12px',boxShadow:'0 2px 8px rgba(0,0,0,0.07)'}}>
              <h3 style={{color:'#e65100',margin:'0 0 10px',fontSize:'14px'}}>📦 Low Stock Alert</h3>
              {lowStock.map((drug,i)=>(
                <div key={i} style={{display:'flex',justifyContent:'space-between',padding:'8px',background:'#fff8f0',borderRadius:'8px',marginBottom:'6px',fontSize:'12px'}}>
                  <div><div style={{fontWeight:'bold'}}>{drug.name}</div><div style={{color:'#666'}}>Min: {drug.minStock}</div></div>
                  <div style={{fontWeight:'bold',color:'#c62828',fontSize:'14px'}}>{drug.totalStock} left</div>
                </div>
              ))}
            </div>
          )}

          <h3 style={{color:'#1a237e',margin:'0 0 10px',fontSize:'14px'}}>🧾 Recent Bills</h3>
          {bills.slice(0,5).map(bill=>(
            <div key={bill._id} className="erp-card" style={{background:'white',borderRadius:'10px',padding:'12px',marginBottom:'8px',boxShadow:'0 2px 6px rgba(0,0,0,0.06)',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
              <div>
                <div style={{fontWeight:'bold',color:'#1a237e',fontSize:'13px'}}>#{bill.billNo}</div>
                <div style={{color:'#666',fontSize:'11px'}}>{bill.customerName} | {new Date(bill.createdAt).toLocaleTimeString('ta-IN',{hour:'2-digit',minute:'2-digit'})}</div>
              </div>
              <div style={{textAlign:'right'}}>
                <div style={{fontWeight:'bold',color:'#2e7d32',fontSize:'14px'}}>₹{bill.grandTotal?.toFixed(2)}</div>
                <div style={{fontSize:'11px',color:bill.paymentStatus==='paid'?'#2e7d32':'#e65100'}}>{bill.paymentStatus==='paid'?'✅ Paid':'⏳ Due'}</div>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* DRUG MASTER / INVENTORY */}
      {tab==='inventory'&&(
        <div style={{padding:'12px'}}>
          <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:'12px'}}>
            <h2 style={{color:'#1a237e',margin:0,fontSize:'17px'}}>💊 Drug Master ({drugs.length})</h2>
            <button onClick={()=>setShowAddDrug(!showAddDrug)} style={btn()}>+ சேர்</button>
          </div>

          {showAddDrug&&(
            <div style={{background:'white',borderRadius:'12px',padding:'16px',marginBottom:'12px',boxShadow:'0 2px 8px rgba(0,0,0,0.08)'}}>
              <h3 style={{color:'#1a237e',margin:'0 0 12px',fontSize:'15px'}}>புதிய மருந்து</h3>
              <input placeholder="மருந்து பெயர் *" value={newDrug.name} onChange={e=>setNewDrug({...newDrug,name:e.target.value})} style={inp}/>
              <input placeholder="Generic பெயர்" value={newDrug.genericName} onChange={e=>setNewDrug({...newDrug,genericName:e.target.value})} style={inp}/>
              <input placeholder="Salt Composition" value={newDrug.saltComposition} onChange={e=>setNewDrug({...newDrug,saltComposition:e.target.value})} style={inp}/>
              <input placeholder="Manufacturer" value={newDrug.manufacturer} onChange={e=>setNewDrug({...newDrug,manufacturer:e.target.value})} style={inp}/>
              <input placeholder="Barcode (optional, scan/type)" value={newDrug.barcode} onChange={e=>setNewDrug({...newDrug,barcode:e.target.value})} style={inp}/>
              <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'8px'}}>
                <select value={newDrug.schedule} onChange={e=>setNewDrug({...newDrug,schedule:e.target.value})} style={{padding:'10px',borderRadius:'8px',border:'1px solid #ddd',fontSize:'13px',marginBottom:'8px'}}>
                  {['OTC','H','H1','X','G'].map(s=><option key={s} value={s}>Schedule {s}</option>)}
                </select>
                <select value={newDrug.drugType} onChange={e=>setNewDrug({...newDrug,drugType:e.target.value})} style={{padding:'10px',borderRadius:'8px',border:'1px solid #ddd',fontSize:'13px',marginBottom:'8px'}}>
                  {['tablet','capsule','syrup','injection','cream','drops','other'].map(t=><option key={t} value={t}>{t}</option>)}
                </select>
              </div>
              <div style={{display:'grid',gridTemplateColumns:'1fr 1fr 1fr',gap:'8px'}}>
                <input placeholder="MRP ₹" type="number" value={newDrug.mrp} onChange={e=>setNewDrug({...newDrug,mrp:e.target.value})} style={{...inp,marginBottom:0}}/>
                <input placeholder="Sale ₹" type="number" value={newDrug.salePrice} onChange={e=>setNewDrug({...newDrug,salePrice:e.target.value})} style={{...inp,marginBottom:0}}/>
                <input placeholder="Purchase ₹" type="number" value={newDrug.purchasePrice} onChange={e=>setNewDrug({...newDrug,purchasePrice:e.target.value})} style={{...inp,marginBottom:0}}/>
              </div>
              <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'8px',marginTop:'8px'}}>
                <select value={newDrug.gstPercent} onChange={e=>setNewDrug({...newDrug,gstPercent:Number(e.target.value)})} style={{padding:'10px',borderRadius:'8px',border:'1px solid #ddd',fontSize:'13px'}}>
                  {[0,5,12,18].map(g=><option key={g} value={g}>GST {g}%</option>)}
                </select>
                <input placeholder="Min Stock" type="number" value={newDrug.minStock} onChange={e=>setNewDrug({...newDrug,minStock:Number(e.target.value)})} style={{...inp,marginBottom:0}}/>
              </div>
              <div style={{background:'#f0f4ff',borderRadius:'8px',padding:'12px',marginTop:'10px'}}>
                <h4 style={{color:'#1a237e',margin:'0 0 8px',fontSize:'13px'}}>Opening Batch (optional)</h4>
                <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'8px'}}>
                  <input placeholder="Batch No" value={newBatch.batchNo} onChange={e=>setNewBatch({...newBatch,batchNo:e.target.value})} style={{...inp,marginBottom:0}}/>
                  <input type="date" value={newBatch.expiryDate} onChange={e=>setNewBatch({...newBatch,expiryDate:e.target.value})} style={{...inp,marginBottom:0}}/>
                  <input placeholder="Qty" type="number" value={newBatch.stock} onChange={e=>setNewBatch({...newBatch,stock:e.target.value})} style={{...inp,marginBottom:0}}/>
                  <input placeholder="Purchase ₹" type="number" value={newBatch.purchasePrice} onChange={e=>setNewBatch({...newBatch,purchasePrice:e.target.value})} style={{...inp,marginBottom:0}}/>
                </div>
              </div>
              <div style={{display:'flex',gap:'8px',marginTop:'12px'}}>
                <button onClick={addDrug} style={{...btn(),flex:1,padding:'11px'}}>✅ சேர்க்கவும்</button>
                <button onClick={()=>setShowAddDrug(false)} style={{...btn('linear-gradient(135deg,#757575,#616161)'),flex:1,padding:'11px'}}>Cancel</button>
              </div>
            </div>
          )}

          {drugs.map(drug=>(
            <div key={drug._id} className="erp-card" style={{background:'white',borderRadius:'10px',padding:'12px',marginBottom:'8px',boxShadow:'0 2px 6px rgba(0,0,0,0.06)'}}>
              <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start'}}>
                <div style={{flex:1}}>
                  <div style={{display:'flex',gap:'6px',alignItems:'center',marginBottom:'3px'}}>
                    <span style={{fontWeight:'bold',color:'#1a237e',fontSize:'13px'}}>{drug.name}</span>
                    <span style={{background:scheduleColor[drug.schedule]+'22',color:scheduleColor[drug.schedule],padding:'1px 6px',borderRadius:'4px',fontSize:'10px',fontWeight:'bold'}}>{drug.schedule}</span>
                    {drug.rx&&<span style={{background:'#ff5722',color:'white',fontSize:'9px',padding:'1px 5px',borderRadius:'3px'}}>Rx</span>}
                  </div>
                  <div style={{color:'#666',fontSize:'11px',marginBottom:'4px'}}>{drug.genericName} | {drug.manufacturer}</div>
                  <div style={{color:'#888',fontSize:'10px',marginBottom:'4px'}}>{drug.saltComposition}</div>
                  <div style={{display:'flex',gap:'6px',flexWrap:'wrap'}}>
                    <span style={{background:'#e8f5e9',color:'#2e7d32',padding:'2px 8px',borderRadius:'10px',fontSize:'10px',fontWeight:'bold'}}>Sale: ₹{drug.salePrice}</span>
                    <span style={{background:'#f3e5f5',color:'#4a148c',padding:'2px 8px',borderRadius:'10px',fontSize:'10px'}}>MRP: ₹{drug.mrp}</span>
                    <span style={{background:'#e3f2fd',color:'#1565c0',padding:'2px 8px',borderRadius:'10px',fontSize:'10px'}}>GST {drug.gstPercent}%</span>
                    <span style={{background:drug.totalStock<drug.minStock?'#ffebee':'#f5f5f5',color:drug.totalStock<drug.minStock?'#c62828':'#666',padding:'2px 8px',borderRadius:'10px',fontSize:'10px',fontWeight:'bold'}}>
                      Stock: {drug.totalStock} {drug.totalStock<drug.minStock?'⚠️':''}
                    </span>
                  </div>
                  {drug.batches?.slice(0,2).map((b,i)=>(
                    <div key={i} style={{fontSize:'10px',color:'#999',marginTop:'4px',background:'#f9f9f9',padding:'3px 6px',borderRadius:'4px',display:'inline-block',marginRight:'4px'}}>
                      {b.batchNo} | Exp: {b.expiryDate?new Date(b.expiryDate).toLocaleDateString('ta-IN'):'-'} | {b.stock} units
                    </div>
                  ))}
                  <div style={{display:'flex',gap:'6px',marginTop:'8px'}}>
                    <button onClick={()=>setEditDrug({...drug})} style={{...btn('linear-gradient(135deg,#1565c0,#0d47a1)'),fontSize:'11px',padding:'5px 12px'}}>✏️ Edit</button>
                    <button onClick={()=>deleteDrug(drug)} style={{...btn('linear-gradient(135deg,#c62828,#b71c1c)'),fontSize:'11px',padding:'5px 12px'}}>🗑️ Delete</button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* PURCHASE / GRN */}
      {tab==='purchase'&&(
        <div style={{padding:'12px'}}>
          <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:'12px'}}>
            <h2 style={{color:'#1a237e',margin:0,fontSize:'17px'}}>📦 Purchase / GRN</h2>
            <button onClick={()=>setShowGRN(!showGRN)} style={btn()}>+ GRN</button>
          </div>

          {showGRN&&(
            <div style={{background:'white',borderRadius:'12px',padding:'16px',marginBottom:'12px',boxShadow:'0 2px 8px rgba(0,0,0,0.08)'}}>
              <h3 style={{color:'#1a237e',margin:'0 0 12px',fontSize:'15px'}}>புதிய GRN — Stock In</h3>
              <input placeholder="Supplier / Company பெயர் *" value={grnSupplier} onChange={e=>setGrnSupplier(e.target.value)} style={inp}/>
              <input placeholder="Invoice Number" value={grnInvoice} onChange={e=>setGrnInvoice(e.target.value)} style={inp}/>
              <input placeholder="🔍 மருந்து தேடுங்கள்..." value={grnDrugSearch} onChange={e=>setGrnDrugSearch(e.target.value)} style={inp}/>
              {grnDrugSearch&&(
                <div style={{background:'#f8f9fa',borderRadius:'8px',maxHeight:'180px',overflow:'auto',marginBottom:'10px',border:'1px solid #e0e0e0'}}>
                  {filteredGrnDrugs.slice(0,6).map(drug=>(
                    <div key={drug._id} onClick={()=>addGrnItem(drug)}
                      style={{padding:'10px 12px',cursor:'pointer',borderBottom:'1px solid #f0f0f0',display:'flex',justifyContent:'space-between'}}>
                      <div>
                        <div style={{fontWeight:'bold',fontSize:'13px'}}>{drug.name}</div>
                        <div style={{color:'#666',fontSize:'11px'}}>{drug.genericName}</div>
                      </div>
                      <span style={{color:'#1a237e',fontWeight:'bold',fontSize:'12px'}}>Purchase: ₹{drug.purchasePrice}</span>
                    </div>
                  ))}
                </div>
              )}
              {grnItems.map((item,i)=>(
                <div key={i} style={{background:'#f0f4ff',borderRadius:'8px',padding:'10px',marginBottom:'8px'}}>
                  <div style={{fontWeight:'bold',color:'#1a237e',fontSize:'13px',marginBottom:'8px'}}>{item.drugName}</div>
                  <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'6px'}}>
                    <input placeholder="Batch No *" value={item.batchNo} onChange={e=>setGrnItems(p=>p.map((x,j)=>j===i?{...x,batchNo:e.target.value}:x))} style={{...inp,marginBottom:0}}/>
                    <input type="date" placeholder="Expiry Date" value={item.expiryDate} onChange={e=>setGrnItems(p=>p.map((x,j)=>j===i?{...x,expiryDate:e.target.value}:x))} style={{...inp,marginBottom:0}}/>
                    <input placeholder="Qty *" type="number" value={item.qty} onChange={e=>setGrnItems(p=>p.map((x,j)=>j===i?{...x,qty:Number(e.target.value)}:x))} style={{...inp,marginBottom:0}}/>
                    <input placeholder="Free Qty" type="number" value={item.freeQty} onChange={e=>setGrnItems(p=>p.map((x,j)=>j===i?{...x,freeQty:Number(e.target.value)}:x))} style={{...inp,marginBottom:0}}/>
                    <input placeholder="Purchase ₹ *" type="number" value={item.purchasePrice} onChange={e=>setGrnItems(p=>p.map((x,j)=>j===i?{...x,purchasePrice:Number(e.target.value)}:x))} style={{...inp,marginBottom:0}}/>
                    <input placeholder="MRP ₹" type="number" value={item.mrp} onChange={e=>setGrnItems(p=>p.map((x,j)=>j===i?{...x,mrp:Number(e.target.value)}:x))} style={{...inp,marginBottom:0}}/>
                    <input placeholder="Discount %" type="number" value={item.discount} onChange={e=>setGrnItems(p=>p.map((x,j)=>j===i?{...x,discount:Number(e.target.value)}:x))} style={{...inp,marginBottom:0}}/>
                    <select value={item.gstPercent} onChange={e=>setGrnItems(p=>p.map((x,j)=>j===i?{...x,gstPercent:Number(e.target.value)}:x))} style={{padding:'10px',borderRadius:'8px',border:'1px solid #ddd',fontSize:'13px'}}>
                      {[0,5,12,18].map(g=><option key={g} value={g}>GST {g}%</option>)}
                    </select>
                  </div>
                  <button onClick={()=>setGrnItems(p=>p.filter((_,j)=>j!==i))} style={{...btn('linear-gradient(135deg,#c62828,#b71c1c)'),marginTop:'8px',fontSize:'11px',padding:'4px 10px'}}>Remove</button>
                </div>
              ))}
              {grnItems.length>0&&(
                <button onClick={submitGRN} disabled={loading} style={{...btn(),width:'100%',padding:'12px',marginTop:'8px'}}>
                  {loading?'⏳ Saving...':'✅ GRN Save — Stock Update பண்ணு'}
                </button>
              )}
            </div>
          )}

          <h3 style={{color:'#1a237e',margin:'0 0 10px',fontSize:'14px'}}>📋 Recent GRNs ({grns.length})</h3>
          {grns.length===0&&<div style={{textAlign:'center',padding:'30px',color:'#999'}}>இன்னும் GRN இல்லை</div>}
          {grns.map(grn=>(
            <div key={grn._id} className="erp-card" style={{background:'white',borderRadius:'10px',padding:'12px',marginBottom:'8px',boxShadow:'0 2px 6px rgba(0,0,0,0.06)'}}>
              <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:'4px'}}>
                <span style={{fontWeight:'bold',color:'#1a237e',fontSize:'13px'}}>#{grn.grnNo}</span>
                <span style={{background:grn.paymentStatus==='paid'?'#e8f5e9':'#fff3e0',color:grn.paymentStatus==='paid'?'#2e7d32':'#e65100',padding:'2px 8px',borderRadius:'10px',fontSize:'11px',fontWeight:'bold'}}>
                  {grn.paymentStatus==='paid'?'✅ Paid':'⏳ Pending'}
                </span>
              </div>
              <div style={{color:'#666',fontSize:'12px'}}>🏭 {grn.supplierName} | Invoice: {grn.invoiceNo||'-'}</div>
              <div style={{color:'#666',fontSize:'12px'}}>{grn.items?.length} items | {new Date(grn.createdAt).toLocaleDateString('ta-IN')}</div>
              <div style={{fontWeight:'bold',color:'#2e7d32',fontSize:'14px',marginTop:'4px'}}>₹{grn.grandTotal?.toFixed(2)}</div>
            </div>
          ))}
        </div>
      )}

      {/* LEDGER / DUE */}
      {tab==='ledger'&&(
        <div style={{padding:'12px'}}>
          <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:'12px'}}>
            <h2 style={{color:'#1a237e',margin:0,fontSize:'17px'}}>👥 நிலுவை கணக்கு</h2>
            <span style={{background:'#ffebee',color:'#c62828',padding:'4px 12px',borderRadius:'20px',fontWeight:'bold',fontSize:'12px'}}>
              ₹{ledgers.reduce((a,l)=>a+l.totalDue,0).toFixed(2)}
            </span>
          </div>
          {ledgers.length===0?(
            <div style={{textAlign:'center',padding:'40px',color:'#999'}}><div style={{fontSize:'50px'}}>✅</div><p>நிலுவை இல்லை!</p></div>
          ):ledgers.map(l=>(
            <div key={l._id} className="erp-card" style={{background:'white',borderRadius:'10px',padding:'14px',marginBottom:'10px',boxShadow:'0 2px 6px rgba(0,0,0,0.06)'}}>
              <div style={{display:'flex',justifyContent:'space-between',marginBottom:'8px'}}>
                <div><div style={{fontWeight:'bold',color:'#1a237e'}}>{l.customerName}</div><div style={{color:'#666',fontSize:'12px'}}>📱 {l.customerPhone}</div></div>
                <div style={{fontWeight:'bold',color:'#c62828',fontSize:'16px'}}>₹{l.totalDue.toFixed(2)}</div>
              </div>
              <button style={{...btn('linear-gradient(135deg,#2e7d32,#1b5e20)'),width:'100%',padding:'8px',fontSize:'12px'}}>💰 பணம் பெற்றேன் (Collect Payment)</button>
            </div>
          ))}
        </div>
      )}

      {/* SUPPLIERS */}
      {tab==='suppliers'&&(
        <div style={{padding:'12px'}}>
          <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:'12px'}}>
            <h2 style={{color:'#1a237e',margin:0,fontSize:'17px'}}>🏭 Suppliers ({suppliers.length})</h2>
            <button onClick={()=>setShowAddSupplier(!showAddSupplier)} style={btn()}>+ சேர்</button>
          </div>

          {showAddSupplier&&(
            <div style={{background:'white',borderRadius:'12px',padding:'16px',marginBottom:'12px',boxShadow:'0 2px 8px rgba(0,0,0,0.08)'}}>
              <h3 style={{color:'#1a237e',margin:'0 0 12px',fontSize:'15px'}}>புதிய Supplier</h3>
              <input placeholder="Company / Supplier பெயர் *" value={newSupplier.name} onChange={e=>setNewSupplier({...newSupplier,name:e.target.value})} style={inp}/>
              <input placeholder="Phone Number" value={newSupplier.phone} onChange={e=>setNewSupplier({...newSupplier,phone:e.target.value})} style={inp}/>
              <input placeholder="GST Number" value={newSupplier.gstNumber} onChange={e=>setNewSupplier({...newSupplier,gstNumber:e.target.value})} style={inp}/>
              <input placeholder="Address" value={newSupplier.address} onChange={e=>setNewSupplier({...newSupplier,address:e.target.value})} style={inp}/>
              <div style={{display:'flex',gap:'8px'}}>
                <button onClick={addSupplier} style={{...btn(),flex:1,padding:'11px'}}>✅ சேர்க்கவும்</button>
                <button onClick={()=>setShowAddSupplier(false)} style={{...btn('linear-gradient(135deg,#757575,#616161)'),flex:1,padding:'11px'}}>Cancel</button>
              </div>
            </div>
          )}

          {suppliers.length===0?(
            <div style={{textAlign:'center',padding:'40px',color:'#999'}}><div style={{fontSize:'50px'}}>🏭</div><p>இன்னும் suppliers சேர்க்கல</p></div>
          ):suppliers.map(s=>(
            <div key={s._id} className="erp-card" style={{background:'white',borderRadius:'10px',padding:'14px',marginBottom:'10px',boxShadow:'0 2px 6px rgba(0,0,0,0.06)'}}>
              <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',marginBottom:'8px'}}>
                <div>
                  <div style={{fontWeight:'bold',color:'#1a237e',fontSize:'14px'}}>{s.name}</div>
                  {s.phone&&<div style={{color:'#666',fontSize:'12px'}}>📱 {s.phone}</div>}
                  {s.gstNumber&&<div style={{color:'#999',fontSize:'11px'}}>GST: {s.gstNumber}</div>}
                  {s.address&&<div style={{color:'#999',fontSize:'11px'}}>{s.address}</div>}
                </div>
                <div style={{fontWeight:'bold',color:s.totalDue>0?'#c62828':'#2e7d32',fontSize:'15px',whiteSpace:'nowrap'}}>
                  {s.totalDue>0?`₹${s.totalDue.toFixed(2)} Due`:'✅ Clear'}
                </div>
              </div>
              {s.totalDue>0&&<button onClick={()=>paySupplier(s)} style={{...btn('linear-gradient(135deg,#2e7d32,#1b5e20)'),width:'100%',padding:'8px',fontSize:'12px'}}>💰 Pay பண்ணு</button>}
            </div>
          ))}
        </div>
      )}

      {/* EXPENSE */}
      {tab==='expense'&&(
        <div style={{padding:'12px'}}>
          <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:'12px'}}>
            <h2 style={{color:'#1a237e',margin:0,fontSize:'17px'}}>💸 செலவுகள்</h2>
            <button onClick={()=>setShowExpense(!showExpense)} style={btn()}>+ சேர்</button>
          </div>
          {showExpense&&(
            <div style={{background:'white',borderRadius:'12px',padding:'16px',marginBottom:'12px',boxShadow:'0 2px 8px rgba(0,0,0,0.08)'}}>
              <select value={expense.category} onChange={e=>setExpense({...expense,category:e.target.value})} style={{...inp}}>
                <option value="">Category தேர்வு செய்யுங்கள்</option>
                {['வாடகை','மின்சாரம்','ஊழியர் சம்பளம்','போக்குவரத்து','பழுதுபார்ப்பு','தண்ணீர்','Internet','வேறு'].map(c=><option key={c} value={c}>{c}</option>)}
              </select>
              <input type="number" placeholder="தொகை ₹" value={expense.amount} onChange={e=>setExpense({...expense,amount:e.target.value})} style={inp}/>
              <input placeholder="குறிப்பு" value={expense.note} onChange={e=>setExpense({...expense,note:e.target.value})} style={inp}/>
              <div style={{display:'flex',gap:'8px'}}>
                <button onClick={addExpense} style={{...btn(),flex:1,padding:'10px'}}>✅ சேர்</button>
                <button onClick={()=>setShowExpense(false)} style={{...btn('linear-gradient(135deg,#757575,#616161)'),flex:1,padding:'10px'}}>Cancel</button>
              </div>
            </div>
          )}
          <div style={{background:'#ffebee',borderRadius:'10px',padding:'12px',marginBottom:'12px',display:'flex',justifyContent:'space-between'}}>
            <span style={{color:'#c62828',fontWeight:'bold'}}>மாத மொத்த செலவு</span>
            <span style={{color:'#c62828',fontWeight:'bold',fontSize:'16px'}}>₹{expenses.reduce((a,e)=>a+e.amount,0).toFixed(2)}</span>
          </div>
          {expenses.map(e=>(
            <div key={e._id} className="erp-card" style={{background:'white',borderRadius:'10px',padding:'12px',marginBottom:'8px',boxShadow:'0 2px 6px rgba(0,0,0,0.06)',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
              <div><div style={{fontWeight:'bold',color:'#1a237e',fontSize:'13px'}}>{e.category}</div><div style={{color:'#666',fontSize:'11px'}}>{e.note} | {new Date(e.date).toLocaleDateString('ta-IN')}</div></div>
              <div style={{fontWeight:'bold',color:'#c62828',fontSize:'14px'}}>₹{e.amount}</div>
            </div>
          ))}
        </div>
      )}

      {/* EDIT DRUG MODAL */}
      {editDrug&&(
        <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.5)',zIndex:190,display:'flex',alignItems:'center',justifyContent:'center',padding:'16px'}}>
          <div style={{background:'white',borderRadius:'14px',padding:'18px',width:'100%',maxWidth:'420px',maxHeight:'85vh',overflow:'auto'}}>
            <h3 style={{color:'#1a237e',margin:'0 0 12px',fontSize:'16px'}}>✏️ மருந்து Edit</h3>
            <input placeholder="மருந்து பெயர்" value={editDrug.name} onChange={e=>setEditDrug({...editDrug,name:e.target.value})} style={inp}/>
            <input placeholder="Generic பெயர்" value={editDrug.genericName} onChange={e=>setEditDrug({...editDrug,genericName:e.target.value})} style={inp}/>
            <input placeholder="Manufacturer" value={editDrug.manufacturer} onChange={e=>setEditDrug({...editDrug,manufacturer:e.target.value})} style={inp}/>
            <input placeholder="Barcode" value={editDrug.barcode||''} onChange={e=>setEditDrug({...editDrug,barcode:e.target.value})} style={inp}/>
            <div style={{display:'grid',gridTemplateColumns:'1fr 1fr 1fr',gap:'8px'}}>
              <input placeholder="MRP ₹" type="number" value={editDrug.mrp} onChange={e=>setEditDrug({...editDrug,mrp:e.target.value})} style={{...inp,marginBottom:0}}/>
              <input placeholder="Sale ₹" type="number" value={editDrug.salePrice} onChange={e=>setEditDrug({...editDrug,salePrice:e.target.value})} style={{...inp,marginBottom:0}}/>
              <input placeholder="Purchase ₹" type="number" value={editDrug.purchasePrice} onChange={e=>setEditDrug({...editDrug,purchasePrice:e.target.value})} style={{...inp,marginBottom:0}}/>
            </div>
            <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'8px',marginTop:'8px'}}>
              <select value={editDrug.gstPercent} onChange={e=>setEditDrug({...editDrug,gstPercent:Number(e.target.value)})} style={{padding:'10px',borderRadius:'8px',border:'1px solid #ddd',fontSize:'13px'}}>
                {[0,5,12,18].map(g=><option key={g} value={g}>GST {g}%</option>)}
              </select>
              <input placeholder="Min Stock" type="number" value={editDrug.minStock} onChange={e=>setEditDrug({...editDrug,minStock:e.target.value})} style={{...inp,marginBottom:0}}/>
            </div>
            <div style={{display:'flex',gap:'8px',marginTop:'14px'}}>
              <button onClick={saveEditDrug} style={{...btn(),flex:1,padding:'11px'}}>✅ Save</button>
              <button onClick={()=>setEditDrug(null)} style={{...btn('linear-gradient(135deg,#757575,#616161)'),flex:1,padding:'11px'}}>Cancel</button>
            </div>
          </div>
        </div>
      )}

      {/* BARCODE SCANNER MODAL */}
      {showScanner&&(
        <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.85)',zIndex:200,display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',padding:'20px'}}>
          <div style={{color:'white',fontWeight:'bold',marginBottom:'10px',fontSize:'15px'}}>📷 Barcode-ஐ camera-க்கு முன்ன வையுங்க</div>
          <video ref={videoRef} style={{width:'100%',maxWidth:'420px',borderRadius:'14px',border:'3px solid #2e7d32'}} muted playsInline></video>
          {scannerMsg&&<div style={{color:'#ff8a80',marginTop:'10px',fontSize:'13px',textAlign:'center'}}>{scannerMsg}</div>}
          <button onClick={stopScanner} style={{...btn('linear-gradient(135deg,#c62828,#b71c1c)'),marginTop:'16px',padding:'10px 24px'}}>✕ Close</button>
        </div>
      )}

      {/* BOTTOM NAV */}
      <div className="erp-nav" style={{position:'fixed',bottom:0,left:'50%',transform:'translateX(-50%)',width:'100%',display:'flex',background:'white',boxShadow:'0 -2px 10px rgba(0,0,0,0.1)',zIndex:100}}>
        {[['🧾','Billing','pos'],['📊','Dashboard','dashboard'],['💊','Drug Master','inventory'],['📦','Purchase','purchase'],['🏭','Suppliers','suppliers'],['👥','கணக்கு','ledger'],['💸','செலவு','expense']].map(([icon,label,t])=>(
          <button key={t} onClick={()=>setTab(t)} style={navBtn(t)}><div style={{fontSize:'15px'}}>{icon}</div><div style={{fontSize:'8px'}}>{label}</div></button>
        ))}
      </div>
    </div>
  );
}
export default App;

